/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_NavInputs */

const en_mk_sol_operasional_nav = /** @type {(inputs: Mk_Sol_Operasional_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operations & back office`)
};

const id_mk_sol_operasional_nav = /** @type {(inputs: Mk_Sol_Operasional_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operasional & back office`)
};

/**
* | output |
* | --- |
* | "Operations & back office" |
*
* @param {Mk_Sol_Operasional_NavInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_nav = /** @type {((inputs?: Mk_Sol_Operasional_NavInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_NavInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_nav(inputs)
	return en_mk_sol_operasional_nav(inputs)
});